import { render, staticRenderFns } from "./OptionHealthAttorneysPrimaryWorkTogetherYN.vue?vue&type=template&id=6b25b6c2"
import script from "./OptionHealthAttorneysPrimaryWorkTogetherYN.vue?vue&type=script&lang=js"
export * from "./OptionHealthAttorneysPrimaryWorkTogetherYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports